<template>
    <article id="page-features">
        <section>
            <h1>Boomerang 2D is a <em>Framework</em>, not a Toolkit</h1>
            <h2>Don't rely on pre-built content. Built your own.</h2>

            <p><b>Toolkits</b> are made up of common pre-built game elements that you can place into your Unity scene. A
                simple drag and drop and you're done... unless you want something unique or specific to your needs. Then
                you either just have to wait and hope the toolkit's developers make it for you, or you're skilled enough
                to scour through thousands and thousands of lines of code and figure out where to put your special
                functionality.</p>

            <p><b>Frameworks</b> are systems that streamline the development of a complex application, while
                creating rules and a structure for all the various elements that make up that application. Boomerang 2D
                gives you that structure without limiting what you can do.</p>

            <p>Instead of using a toolkit to attach a Jetpack script that someone else wrote and only works with a
                limited predefined set of configurations, you should be using a Framework that lets you easily create
                that Jetpack with your own configurations, controls, functionality, and customization from the
                ground-up. With <b>Boomerang 2D</b>, you can do exactly that, and with out writing any code at all.</p>
        </section>

        <section>
            <div class="youtube-iframe-wrapper">
                <iframe class="real-youtube-container"
                        width="560" height="315"
                        src="https://www.youtube.com/embed/CQTwr4zUfbo"
                        title="Boomerang 2D Trailer"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                >
                </iframe>
            </div>
        </section>

        <section>
            <h1>The Actor Studio</h1>

            <p>Using a robust set of configurations, quickly and easily create all sorts of Interactive
                Objects, including your Player Character, Enemies, Moving Platforms, Projectiles, Doors, and
                more.</p>

            <img src="../../assets/features-actor-studio-overview.png" alt="Actor Studio Example">

            <div class="columns">
                <div class="column">
                    <h3>Finite State Machine</h3>
                    <p>Manage your Actor's behaviors easily with a visual FSM. For each state, you have complete control
                        over the behavior, transitions into other states, animations, sound effects, and game events
                        that execute every time the state is transitioned into.</p>

                    <p>Boomerang 2D ships with a handful of State Behaviors that cover most cases, but if you need
                        something unique to your project, creating your own state behavior is easy and quick. Just write
                        the behavior class and drop it in the correct folder, and it will immediately be integrated into
                        the Visual Editor.</p>
                </div>
                <div class="column">
                    <img src="../../assets/features-actor-state-machine.png" alt="Finite State Machine Example">
                </div>
            </div>
        </section>

        <section>
            <h1>The Tileset Studio</h1>

            <p>Easily import and manage Tiles for use in the Map Editor. Control flags, Collider shapes and properties,
                and animation frames. </p>
            <img src="../../assets/features-tileset-studio.png" alt="Tileset Studio Example">

            <div class="columns">
                <div class="column">
                    <h3>Organize your Tiles into Stamps</h3>
                    <img src="../../assets/features-tileset-studio-stamps.png" alt="Tileset Studio Stamps Example"
                    ></div>

                <div class="column">
                    <h3>Build Brushes that let you paint with auto-tiles</h3>
                    <img src="../../assets/features-tileset-studio-brushes.png" alt="Tileset Studio Brushes Example">
                </div>
            </div>
        </section>

        <section>
            <h1>The Map Editor</h1>

            <p>Using the Tiles you created, make maps with lots of features like Camera Views, Placing Actors and
                Painting Brushes, and placing non-Boomerang 2D assets. </p>
            <img src="../../assets/features-map-editor.png" alt="Map Editor Example">

        </section>

        <section>
            <h1>The Hud Object Editor</h1>

            <p>Build reusable HUD Layouts for Dialog Boxes, Inventory Menus, and more. Boomerang 2D ships with a handful
                of HUD Elements, and new ones can be easily written and integrated into the interface. If you prefer to
                use Unity's build-in UI system, you can do that, too! </p>
            <img src="../../assets/features-hud-object-editor.png" alt="Hud Object Editor Example">

            <div class="columns">
                <div class="column">
                    <h3>Build your own Bitmap Font assets</h3>
                    <img src="../../assets/features-bitmap-fonts.png" alt="Bitmap Fonts Example"
                    ></div>

                <div class="column">
                    <h3>Pull data from a built-in Text Content Editor</h3>
                    <img src="../../assets/features-text-content-editor.png" alt="Text Content Editor Example">
                </div>
            </div>
        </section>

    </article>
</template>

<script>
    export default {
        name: "Features"
    }
</script>